<template>
<div>
    <div>
        <div class="centered-div">
            <h3 class="register-text"><b>Invite company to DataMapper</b></h3>
        </div>
        <div v-if="success" class="success-text">
            <h3 class="success-h3">Success! We're sending you an invite.</h3>
            <div class="success-body-text">
            Just follow the link in the email
            and you will be organizing <br/> your documents in no time!
            </div>
        </div>
        <div v-if="!success">
            <div class="grid">
                <div class="centered-div">
                <form v-on:submit='createUser' class="register-form" @submit.prevent="noRefresh">
                    <div class="email-label-text">
                        Email to invite
                    </div>
                    <input type="email" placeholder="your@email.com" v-model="email"/>
                    <div class="passcode-label-text">
                        Your admin passcode
                    </div>
                     <input type="password" placeholder="admin passcode" v-model="passcode"/>
                    <div class="validation-block">
                        <p v-if="!$v.email.required && submitted">The email field is required.</p>
                        <p v-if="!$v.email.email && submitted">The email must be valid.</p>
                        <p v-if="!$v.passcode.required && submitted">The passcode field is required.</p>
                    </div>
                    <br/>
                    <div class="invite-text">
                        The user will receive an email invitation to DataMapper.
                    </div>
                </form>
                <button class="register-button" @click="createUser">continue</button>
            </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import { required, email } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'

export default {
    data () {
        return {
            email: '',
            passcode: '',
            errorMessage: "",
            success: false,
            submitted: false
        }
    },
    computed: {
        ...mapState(['pageInfo'])
    },

    methods: {
        noRefresh () {},
        createUser: function () {
            this.submitted = true
            if(!this.$v.email.required || !this.$v.email.email || !this.$v.passcode.required) return
            if(this.passcode != 'CarrotClue!234') {
                return this.$store.dispatch('error', { message: 'Wrong passcode'})
            }
            this.$store.commit('updatePageInfo', {
                ...this.pageInfo,
                loading: true
            })
            const self = this
            this.$Api.admin.register(
                this.email,
                true
            ).then(
                () => { self.success = true }
            ).catch(
                error => {
                    if (error.message === 'userExists') {
                        return self.$store.dispatch('error', { message: 'The user already exists.' })
                    }
                    else {
                        return self.$store.dispatch('error', {
                            message: 'Something unexpected happen. ' +
                            'Please try again later. Reason: ' + error.message
                        })
                    }
                }
            ).finally(() => { self.$store.commit('updatePageInfo', {...self.pageInfo, loading: false})
            })
        }
    },
    validations: {
        email: {
            required, email
        },
        passcode: {
            required
        }
    }
}

</script>

<style lang="scss">
@import "~@/assets/scss/index.scss";

    .centered-div {
        width: 60%;
        margin: 0 auto;
    }

    .form form.register-form {
        width: 100%;
        min-height: 0;
        margin-bottom: 20px;

        input {
            width: 100%;
        }

        .validation-block {
            margin-top: 4px;
            height: auto;
        }

        p {
            font-size: 13px;
            color: red;
        }
    }

    div.email-label-text {
        font-size: 16px;
    }
    div.passcode-label-text {
        font-size: 16px;
        margin-top: 10px;
    }
    div.invite-text {
        font-size: 11px;
    }

    .form button.register-button {
        width: 100%;
        padding: 15px 40px;
        margin-bottom: 20px;
    }

    .register-text {
        padding-top: 30px;
        text-align: center;
        font-size: 20px;
    }

    .success-body-text {
        margin-top: 10px;
    }
    .success-text {
        .success-h3 {
            font-size: 20px;
        }
        margin-top: 50px;
        text-align: center;
    }

</style>



// WEBPACK FOOTER //
// apps/account/RegisterGDPR.vue